import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/**
 * HistoryHubSkeleton — shimmer placeholder for the full history list page
 * while certs are loading.
 */
export function HistoryHubSkeleton(): React.ReactElement {
  return (
    <Box>
      {/* PageHeader area */}
      <Skeleton
        variant="rectangular"
        height={56}
        animation="wave"
        sx={{ mb: 0 }}
      />

      <Stack sx={{ gap: 1.5, px: 2, pt: 2, pb: '100px' }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 2,
              bgcolor: 'background.paper',
              borderRadius: '14px',
              boxShadow: '0 1px 8px rgba(0,0,0,0.03)',
            }}
          >
            <Skeleton
              variant="rounded"
              width={40}
              height={40}
              animation="wave"
            />
            <Stack sx={{ flex: 1, gap: 0.5 }}>
              <Skeleton
                variant="text"
                width="70%"
                height={18}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="50%"
                height={14}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="40%"
                height={14}
                animation="wave"
              />
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
